import {
  CatalogSearchResultItem,
  ColumnDefinition,
  FieldRenderer,
  ResourceCatalogApplication,
} from '../types';
import { DevHubLink, DevHubTypography } from '@devxdiscover/devhub-ui';
import { NavLink } from 'react-router-dom';
import { Fragment } from 'react';
import { Column } from 'primereact/column';

const getApplications = (
  row: CatalogSearchResultItem,
): ResourceCatalogApplication[] => {
  if ('applicationsPaged' in row?.item) {
    return row.item.applicationsPaged?.applications;
  }
  return [] as ResourceCatalogApplication[];
};

const applicationLinkTemplate = (row: CatalogSearchResultItem) => {
  const applications = getApplications(row);

  if (applications?.length > 0) {
    return applications.map(
      (app: ResourceCatalogApplication, index: number) => (
        <Fragment key={app?.applicationId}>
          <DevHubLink
            component={NavLink}
            to={`/catalog/default/system/${app?.applicationId}`}
          >
            {app?.name}
          </DevHubLink>
          {index < applications.length - 1 ? ', ' : null}
        </Fragment>
      ),
    );
  }

  return <DevHubTypography>No application association</DevHubTypography>;
};

/**
 * Renders the owner org field
 * @param col The column definition
 * @param index The index of the column
 */
export const applicationLinkRenderer: FieldRenderer = (
  col: ColumnDefinition,
  index: number,
) => {
  return (
    <Column
      key={index}
      field={col.field}
      header={col.header}
      style={{ width: col.width }}
      body={applicationLinkTemplate}
    />
  );
};
